import Chart from 'chart.js/auto';
const chartjs = require('../../../../../../components/chart/chartjs');
const math = require('../../../../../../js-handler/math');

function buildTreemapDataFromRows(rows) {
    if (!Array.isArray(rows) || rows.length === 0) return null;
    const out = [];

    for (const row of rows) {
        if (!row || row.id === 'nothing') continue;

        const qty = parseFloat(row.available);
        const q = Number.isFinite(qty) ? qty : 0;

        // 1. Limpieza precisa del string monetario (eliminar comas y caracteres)
        const rawInventoryValue = row.current_inventory_value 
            ? String(row.current_inventory_value).replace(/,/g, '').replace(/[^0-9.-]/g, '') 
            : '0';
        const totalNum = parseFloat(rawInventoryValue) || 0;

        // 2. Extraer datos con respaldo de Marca y Unidad de Empaque
        const name = `${row.name}`.trim() || row.code || 'Item';
        const unitName = row.item_unit_name ? ` - ${row.item_unit_name.trim()}` : '';
        const brandPart = row.brand ? ` (${row.brand.trim()})` : '';
        const codePart = row.code ? ` [${row.code}]` : '';

        // 3. Etiqueta Única Visual (Ejemplo: "KABOCHA - LOCAL 6/8 (QUALITY SQUASH)")
        const displayTitle = `${name}${unitName}${brandPart}`;
        const fullName = `${displayTitle}${codePart}`;

        const value = totalNum > 0 ? totalNum : Math.max(q, 0.01);

        out.push({
            // ID compuesto único para evitar colisiones de rectángulos
            id: `${row.id}_${row.item_unit_id || 'default'}`, 
            name: displayTitle,
            fullName: fullName,
            unit: row.item_unit_name || 'N/A',
            value: value,
            qty: q,
            inversion: row.inversion || 0,
            inventoryTotal: math.cashFormat(totalNum),
            inventoryTotalFormatted: math.cashFormat(totalNum),
        });
    }

    if (!out.length) return null;

    // Ordenamiento estricto descendente por el valor del dinero retenido
    return out.sort((a, b) => b.value - a.value);
}

export function createTreemapChart(rowsOrEmpty) {
    const chartContainer = document.querySelector('#item-page-chart');
    if (!chartContainer) return;


    const previousCanvas = chartContainer.querySelector('canvas');
    const existingChart = previousCanvas ? Chart.getChart(previousCanvas) : null;
    if (existingChart) {
        existingChart.destroy();
    }
    chartContainer.innerHTML = '<canvas class="chartjs" id="itemTreemapChart"></canvas>';
    const canvas = document.getElementById('itemTreemapChart');

    const fromApi = buildTreemapDataFromRows(rowsOrEmpty);
    const data = fromApi || [
        { name: '—', value: 1, fullName: 'Sin datos', qty: 0, inventoryTotal: 0, inventoryTotalFormatted: '0.00' },
    ];

    chartjs.start({
        elem: 'treemap',
        act: 'createSimple',
        targetChart: { html: canvas },
        data: data,
        options: {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 10 / 9
        }
    });
}
